// Mock data for Prestige Investissement style landing page
// NOTE: All data is mocked (frontend only). Prices are the original fees divided by two.

export const navLinks = [
  { label: "Gestion locative", href: "/#accompagnement" },
  { label: "Offres", href: "/#tarifs" },
  { label: "Loyers impayés", href: "/#gli" },
  { label: "Conseils", href: "/#faq" },
  { label: "Cas clients", href: "/#avis" },
  { label: "Notre cabinet", href: "/#cabinet" },
];

export const hero = {
  eyebrow: "Gestion locative · Tarifs imbattables",
  title: "Gestion locative, avec une meilleure rentabilité",
  subtitle: "Un gestionnaire qui connaît votre bien et vous répond.",
  description:
    "Un gestionnaire dédié, un suivi 100 % digital et des loyers garantis : votre bien géré sans effort, votre rentabilité optimisée.",
  primaryCta: "Confier mon bien",
  secondaryCta: "Estimer mon loyer",
  image:
    "https://images.unsplash.com/photo-1656646424687-b303e1758b36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  videoId: "WIw7hdsa5vE",
};

export const situations = [
  {
    title: "Je souhaite mettre mon bien en location",
    text: "Loyer, préparation du logement, recherche du locataire : faisons le point sur les prochaines étapes.",
  },
  {
    title: "Mon bien est déjà géré par une agence",
    text: "Nous étudions votre situation et votre mandat actuel pour préparer la continuité de la gestion.",
  },
  {
    title: "Je gère seul et souhaite déléguer",
    text: "Présentez-nous votre logement et ce qui vous prend du temps. Nous préparons la reprise avec vous.",
  },
];

export const rating = {
  score: "4,7/5",
  count: "+ de 500 avis Google",
};

export const testimonials = [
  {
    name: "Julia U.",
    role: "Responsable comptabilité",
    review:
      "Très satisfait de la gestion de mon appartement : sérieux, efficacité et zéro prise de tête. Mention spéciale à Julia en comptabilité, toujours disponible et super efficace avec le syndic. Une vraie tranquillité d'esprit !",
    reviewer: "Eric Marcus",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=480",
  },
  {
    name: "Ryan T.",
    role: "Gestionnaire",
    review:
      "Merci à l'équipe et en particulier à Ryan pour ses précieux conseils juridiques concernant la procédure de recouvrement. Un accompagnement clair, professionnel et efficace !",
    reviewer: "Tania Eriale",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=480",
  },
  {
    name: "Sophie C.",
    role: "Directrice générale",
    review:
      "Excellente agence, très réactive. Sophie a répondu à toutes nos demandes et à toutes nos attentes.",
    reviewer: "Guillaume Hos",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=480",
  },
  {
    name: "Élodie P.",
    role: "Gestionnaire",
    review:
      "Merci à Loyaris pour leur réactivité, leur sérieux et leur professionnalisme. Merci à Élodie pour les démarches.",
    reviewer: "Noé Bernard",
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=480",
  },
  {
    name: "Paloma P.",
    role: "Assistante de gestion",
    review:
      "Je recommande cette agence ! Merci à Paloma pour sa réactivité, sa disponibilité et son professionnalisme. Très bonne expérience pour ma part.",
    reviewer: "Charlène Le Roux",
    image:
      "https://images.unsplash.com/photo-1699899657680-421c2c2d5064?crop=entropy&cs=srgb&fm=jpg&q=85&w=480",
  },
  {
    name: "Eva F.",
    role: "Assistante de gestion",
    review:
      "Très bonne expérience, merci pour l'accueil d'Eva. Une équipe très professionnelle et attentive pour la clientèle. Merci à vous tous.",
    reviewer: "Martinez Jeniffer",
    image:
      "https://images.unsplash.com/photo-1718209881007-c0ecdfc00f9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=480",
  },
];

export const accompaniment = {
  eyebrow: "Notre accompagnement",
  title: "Un gestionnaire identifié, une équipe à vos côtés.",
  steps: [
    {
      num: "01",
      title: "Vous savez qui contacter",
      text: "Votre gestionnaire suit votre logement et votre locataire. Vous pouvez échanger avec notre équipe et nous rencontrer à l'agence.",
    },
    {
      num: "02",
      title: "Nous coordonnons le suivi",
      text: "Location, loyers et interventions : les personnes qui travaillent sur votre dossier partagent les informations utiles.",
    },
    {
      num: "03",
      title: "Vous gardez la visibilité",
      text: "Comptes, devis et échéances : nous vous expliquons les éléments nécessaires pour prendre vos décisions.",
    },
  ],
  timeline: {
    title: "Une prise en charge en trois temps",
    items: [
      {
        title: "Nous échangeons sur votre bien",
        text: "Votre situation, vos attentes et les pièces du dossier.",
      },
      {
        title: "Nous organisons la transition",
        text: "Première location ou reprise d'un logement déjà loué.",
      },
      {
        title: "Votre gestionnaire prend le relais",
        text: "Suivi du locataire, des comptes et des interventions.",
      },
    ],
    image:
      "https://images.unsplash.com/photo-1592229506151-845940174bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
};

// Prices are the original fees DIVIDED BY TWO
export const services = {
  eyebrow: "Nos services",
  title: "Deux niveaux d'accompagnement. La même exigence.",
  plans: [
    {
      tag: "Formule Liberté",
      name: "Les essentiels de votre gestion",
      description: "Une gestion courante rigoureuse, avec un interlocuteur identifié.",
      price: "3,60 %",
      priceNote: "TTC du loyer charges comprises encaissé",
      features: [
        "Émission des avis d'échéance et des quittances de loyer",
        "Encaissement des loyers et des charges",
        "Reversement des loyers par virement bancaire",
        "Établissement d'un compte rendu de gestion mensuel",
        "Vérification annuelle des attestations d'assurance et des contrats d'entretien",
        "Révision annuelle du loyer",
        "Suivi des impayés et des sinistres (en cas de souscription à l'assurance loyers impayés)",
      ],
      cta: "Choisir la Formule Liberté",
      highlight: false,
    },
    {
      tag: "Formule Sérénité",
      name: "Un accompagnement plus étendu",
      description: "La Formule Liberté complétée par un suivi renforcé.",
      price: "4,20 %",
      priceNote: "TTC du loyer charges comprises encaissé",
      features: [
        "Émission des avis d'échéance et des quittances de loyer",
        "Encaissement des loyers et des charges",
        "Reversement des revenus locatifs par virement bancaire",
        "Établissement d'un compte rendu de gestion mensuel",
        "Vérification annuelle des attestations d'assurance et d'entretien",
        "Révision annuelle du loyer",
        "Régularisation annuelle des charges locatives",
        "Suivi des impayés et des sinistres (en cas de souscription à l'assurance loyers impayés)",
        "Paiement des appels de fonds du syndic",
        "Demande de devis et suivi des travaux d'entretien (avec votre accord préalable)",
        "Paiement des factures des différents fournisseurs",
        "Pré-déclaration des revenus fonciers",
      ],
      cta: "Choisir la Formule Sérénité",
      highlight: true,
    },
  ],
  option: {
    label: "Option — Assurance loyers impayés (GLI)",
    price: "2,10 %",
    note: "couverture MMA Assurances — sans franchise ni délai de carence",
  },
};

export const gli = {
  eyebrow: "Assurance loyers impayés (GLI)",
  title: "Vos loyers garantis, en toutes situations.",
  intro:
    "Grâce à notre contrat d'assurance loyers impayés (MMA Assurances n° 112 789 043), vos revenus locatifs sont sécurisés en cas de défaillance du locataire — sans mauvaise surprise, et avec un accompagnement juridique complet.",
  badges: ["Sans franchise", "Sans délai de carence", "Sans plafond de loyer"],
  cards: [
    {
      icon: "ShieldCheck",
      title: "Loyers impayés",
      subtitle: "Indemnisation jusqu'à récupération du bien",
      points: [
        "Loyers, charges et taxes impayés pris en charge (bail loi du 6 juillet 1989)",
        "Sans franchise, ni plafond de loyer",
        "Aucun délai de carence",
        "Indemnisation dès le commandement de payer, contre quittance subrogatoire",
      ],
    },
    {
      icon: "Home",
      title: "Détériorations immobilières",
      subtitle: "Garantie optionnelle",
      points: [
        "Jusqu'à 10 000 € par sinistre",
        "Pas de franchise",
        "Indemnisation sur facture",
        "Taux de vétusté contractuel (art. 12)",
      ],
    },
    {
      icon: "Scale",
      title: "Frais de contentieux & procédure",
      subtitle: "Un accompagnement juridique de bout en bout",
      points: [
        "Frais du commandement de payer pris en charge dès la 1re indemnisation",
        "Frais de justice liés aux impayés pris en charge",
        "Prise en charge totale (commissaire de justice / avocat) si le dossier est confié à la compagnie",
        "Jusqu'à 4 575 € si vous choisissez votre propre avocat (art. 21)",
      ],
    },
  ],
  footnote:
    "Garanties résumées à titre indicatif, conformes au contrat MMA Assurances n° 112 789 043. Les conditions générales et le détail des garanties, plafonds et exclusions vous sont remis avant toute souscription.",
};

export const faq = [
  {
    q: "Qui s'occupera de mon appartement au quotidien ?",
    a: "Un gestionnaire identifié connaît votre bien, vos locataires et l'historique de votre dossier. Il s'appuie sur notre équipe comptable et location pour assurer le suivi au quotidien. Vous pouvez échanger avec lui par téléphone, par email ou à notre siège du 128 rue la Boétie (Paris 8), et retrouver tous vos documents dans votre espace client en ligne.",
  },
  {
    q: "Combien coûte la gestion de mon bien ?",
    a: "Nos honoraires de gestion sont de 3,6 % TTC pour la Formule Liberté ou de 4,20 % TTC pour la Formule Sérénité, calculés sur le loyer charges comprises encaissé. L'assurance loyers impayés (GLI) est proposée en option à 2,1 %. Les honoraires de mise en location et les éventuelles prestations à l'acte sont distincts : nous vous présentons le détail avant tout engagement.",
  },
  {
    q: "Je suis déjà chez un autre gestionnaire : comment vous rejoindre ?",
    a: "Envoyez-nous votre mandat actuel : nous examinons avec vous les modalités de fin de contrat et le calendrier possible. Nous organisons ensuite la transmission du dossier, des comptes et des documents avec votre ancien gestionnaire, puis informons le locataire. Notre équipe vous accompagne à chaque étape de la reprise.",
  },
  {
    q: "Comment choisissez-vous le locataire et sécurisez-vous les loyers ?",
    a: "Notre équipe étudie les justificatifs, les revenus et la cohérence de chaque dossier avant de vous présenter une candidature. Si vous choisissez l'assurance loyers impayés (GLI), nous constituons le dossier et le soumettons à notre partenaire Garantme pour obtenir l'agrément de l'assureur. Votre gestionnaire suit ensuite les encaissements et les éventuels retards.",
  },
  {
    q: "Mon logement est déjà loué : pouvez-vous reprendre sa gestion ?",
    a: "Oui, vous pouvez nous confier un logement occupé. Nous reprenons le bail en cours, les comptes et les documents du logement, puis prenons contact avec votre locataire pour lui présenter son nouvel interlocuteur et les modalités de paiement. Vous n'avez pas besoin d'attendre son départ pour nous rejoindre.",
  },
];

export const contact = {
  eyebrow: "Votre projet locatif",
  title: "Échangez directement avec notre équipe.",
  text: "Présentez-nous votre situation, notre équipe vous explique comment elle peut vous accompagner.",
  phone: "01 84 17 71 64",
  phoneRaw: "+33184177164",
  address: "128 rue la Boétie, 75008 Paris",
};

export const cabinet = {
  eyebrow: "Notre cabinet",
  title: "Un cabinet entièrement digitalisé, toujours sur le terrain.",
  text: "Notre siège se situe au 128 rue la Boétie, dans le 8e arrondissement de Paris. Mais nos gestionnaires ne restent pas derrière un guichet : outils 100 % digitaux pour un suivi en temps réel, et présence terrain au plus près de votre bien et de vos locataires. Plus de 10 ans d'existence au service d'une gestion de qualité.",
  highlights: [
    {
      icon: "Laptop",
      title: "100 % digitalisé",
      text: "Suivez vos loyers, comptes et documents en temps réel depuis votre espace client en ligne.",
    },
    {
      icon: "MapPin",
      title: "Présence terrain",
      text: "Nos gestionnaires se déplacent au plus près de votre bien et de vos locataires.",
    },
    {
      icon: "TrendingUp",
      title: "Meilleure rentabilité",
      text: "Le meilleur rapport qualité / disponibilité / prix pour optimiser votre investissement.",
    },
    {
      icon: "ShieldCheck",
      title: "Loyers sécurisés",
      text: "Une GLI qui garantit le versement de vos loyers en toutes situations.",
    },
  ],
  stats: [
    { value: "10+", label: "années d'existence" },
    { value: "24/7", label: "espace client en ligne" },
    { value: "100 %", label: "digital & terrain" },
    { value: "GLI", label: "loyers garantis" },
  ],
  image:
    "https://images.unsplash.com/photo-1706689656095-168768dc20a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const footer = {
  tagline: "Gestion locative à Paris · Des tarifs imbattables, sans compromis sur le service.",
  columns: [
    {
      title: "Services",
      links: [
        { label: "Gestion locative", href: "/#accompagnement" },
        { label: "Loyers impayés", href: "/#gli" },
        { label: "Estimation de loyer", href: "/estimation-loyer" },
      ],
    },
    {
      title: "Le cabinet",
      links: [
        { label: "Notre équipe", href: "/#cabinet" },
        { label: "Cas clients", href: "/#avis" },
        { label: "Conseils", href: "/#faq" },
      ],
    },
    {
      title: "Contact",
      links: [
        { label: "128 rue la Boétie, 75008 Paris" },
        { label: "Lun–ven 9h–19h · Sam 10h–13h" },
        { label: "contact@loyaris.fr", href: "mailto:contact@loyaris.fr" },
      ],
    },
  ],
};
